import { createSlice } from "@reduxjs/toolkit";

export const initialLineartProgress = {
  isProcessing: false,
  currentImage: 0,
  totalImages: 0,
  overallPercentage: 0,
  currentStage: '',
  completedImages: 0,
};

const initialState = {
  activeBookId: null,
  fetchingImages: false,
  uploadingCoverImage: false,
  uploadingImages: [], // For individual image tracking (legacy polling)
  uploadingImagesBatch: false, // For batch upload status (Socket.IO)
  uploadingNewImages: [],
  shouldWarmupCover: false,
  shouldWarmupLineart: false,
  lineartProgressByBook: {},
  steps: [], // fetched from /steps/list
  currentStepIndex: 0, // local index
  currentStepId: null, // backend stepId
  isComingFromNonUserRoute: false,
  forceBookRefresh: 0,
};

const stepSlice = createSlice({
  name: "stepFlow",
  initialState,
  reducers: {
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStepIndex = action.payload.index;
      state.currentStepId = action.payload.stepId;
    },
    setActiveBookId: (state, action) => {
      state.activeBookId = action.payload.bookId;
      if (!!action.payload.bookId) {
        localStorage.setItem('activeBookId', action.payload.bookId)
      } else {
        state.fetchingImages = false
      }
    },
    setForceBookRefresh: (state, action) => {
      state.forceBookRefresh = state.forceBookRefresh + action.payload
    },
    setCoverImageUploadStatus: (state, action) => {
      state.uploadingCoverImage = !!action.payload
    },
    //  FIXED: For individual image tracking (legacy polling)
    setImageUploadStatus: (state, action) => {
      // Handle both old format { type: 'add', id: ... } and new format (boolean)
      if (typeof action.payload === 'boolean') {
        // New Socket.IO format - use batch flag
        state.uploadingImagesBatch = action.payload;
      } else if (action.payload.type === 'add') {
        state.uploadingImages = [...state.uploadingImages, action.payload.id];
      } else if (action.payload.type === 'remove') {
        state.uploadingImages = state.uploadingImages.filter(img => img !== action.payload.id);
      }
    },
    // Dedicated action for batch upload status
    setImageBatchUploadStatus: (state, action) => {
      state.uploadingImagesBatch = !!action.payload;
    },
    setMultiNewImages: (state, action) => {
      state.uploadingNewImages = [...state.uploadingNewImages, ...action.payload]
    },
    setNewImageUploadStatus: (state, action) => {
      state.uploadingNewImages = action.payload.type === 'add' 
        ? [...state.uploadingNewImages, action.payload.id] 
        : state.uploadingNewImages.filter(img => img !== action.payload.id)
      console.log('updated one', state.uploadingNewImages)
    },
    setIsComingFromNonUserRoute: (state, action) => {
      state.isComingFromNonUserRoute = !!action.payload
    },
    setLineartProgressByBook: (state, action) => {
      const { bookId, ...rest } = action.payload;

      const prev = state.lineartProgressByBook[bookId] || {};

      Object.keys(rest).forEach((key) => {
        if (rest[key] !== undefined) {
          prev[key] = rest[key];
        }
      });

      if (!action.payload.overallPercentage) {
        console.log('action.payload.overallPercentage', action.payload.overallPercentage)
      }

      state.lineartProgressByBook[bookId] = prev;
    },
    resetStep: (state, action) => {
      state.activeBookId = null
      state.fetchingImages = false
      state.uploadingCoverImage = false
      state.uploadingImages = []
      state.uploadingImagesBatch = false
      state.uploadingNewImages = []

      localStorage.removeItem('activeBookId');
    },
    setUploadingImages: (state, action) => {
      state.uploadingImages = Array.isArray(action.payload) && !action.payload.length ? [] : [...state.uploadingImages, (action.payload || [])]
    },
    setFetchingImages: (state, action) => {
      state.fetchingImages = !!action.payload
    },
    setShouldWarmupCover: (state, action) => {
      state.shouldWarmupCover = !!action.payload
    },
    setShouldWarmupLineart: (state, action) => {
      state.shouldWarmupLineart = !!action.payload
    },
    clearUploadingImages: (state, action) => {
      state.uploadingImages = []
    },
  },
});

export const { 
  setSteps, 
  setCurrentStep, 
  setActiveBookId, 
  setForceBookRefresh, 
  setCoverImageUploadStatus, 
  setImageUploadStatus, 
  setImageBatchUploadStatus,
  setNewImageUploadStatus, 
  setIsComingFromNonUserRoute, 
  resetStep, 
  setMultiNewImages,
  setUploadingImages,
  setFetchingImages,
  setShouldWarmupCover,
  setShouldWarmupLineart,
  setLineartProgressByBook,
  clearUploadingImages
} = stepSlice.actions;

export default stepSlice.reducer;